var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"canvas-toolbox"},[_c('transition',{attrs:{"name":"slide"}},[(_vm.showCanvasToolbox)?_c('tr-canvas-toolbox',{staticClass:"toolbox-class"}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }